import { useMemo } from "react";
import { ZERO_WIDTH_SPACE } from "../../../utils/ZERO_WIDTH_SPACE";
import cx from "classnames";

export const EmbeddedAsteriskHighlight = ({
  children,
}: {
  children: string;
}) => {
  return useMemo(() => {
    if (typeof children !== "string") {
      return children;
    }

    let highlightStarted = false;

    const words = children.split(new RegExp(`([ ]|[${ZERO_WIDTH_SPACE}])`));

    const domWords = words.map((word, index) => {
      const startMatch = word.match(/\*[^\s]/);
      const endMatch = word.match(/[^\s]\*/);
      if (startMatch) {
        highlightStarted = true;
      }
      const domWordsValue = (
        <span key={index}>
          <span
            className={cx(
              highlightStarted && "text-palette-current-foreground"
            )}
          >
            <span>{highlightStarted ? word.replace(/\*/g, "") : word}</span>
          </span>{" "}
        </span>
      );
      if (endMatch) {
        highlightStarted = false;
      }

      return domWordsValue;
    });

    return domWords;
  }, [children]);
};
